import {
  LOGOUT_COMPLETE,
  QUERY_RAG_FLOW_FAILURE,
  QUERY_RAG_FLOW_REQUEST,
  QUERY_RAG_FLOW_SUCCESS,
  RESET_RAG,
  SET_RAG_NODE_FORM_DATA,
  SET_RAG_QUERY,
} from 'js/constants/actionTypes';

const initialState = {
  query: '',
  nodeFormData: {}, // nodeFormData[flowNodeId] = <formData>
  queryResponse: {}, // queryResponse[flowId][llmSinkId] = <response string>
};

const ragReducer = (state = initialState, action) => {
  switch (action.type) {
    case QUERY_RAG_FLOW_SUCCESS:
      return saveQueryResponse(state, action);
    case QUERY_RAG_FLOW_REQUEST:
      return saveQueryRagRequest(state, action);
    case QUERY_RAG_FLOW_FAILURE:
      return saveQueryRagFail(state, action);

    case SET_RAG_QUERY:
      return setQuery(state, action);

    case SET_RAG_NODE_FORM_DATA:
      return setRAGNodeFormData(state, action);

    case RESET_RAG:
    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

const saveQueryResponse = (state, action) => {
  const {
    result,
    requestInfo: { flowId, llmSinkId },
  } = action;

  return {
    ...state,
    queryRequest: {
      ...state.queryRequest,
      [flowId]: {
        loading: false,
      },
    },
    queryResponse: {
      ...state.queryResponse,
      [flowId]: {
        ...state.queryResponse[flowId],
        [llmSinkId]: result,
      },
    },
  };
};

const saveQueryRagFail = (state, action) => {
  const {
    result,
    requestInfo: { flowId, llmSinkId },
  } = action;

  return {
    ...state,
    queryRequest: {
      ...state.queryRequest,
      [flowId]: {
        loading: false,
      },
    },
  };
};

const saveQueryRagRequest = (state, action) => {
  const {
    result,
    requestInfo: { flowId, llmSinkId },
  } = action;

  return {
    ...state,
    queryRequest: {
      ...state.queryRequest,
      [flowId]: {
        loading: true,
      },
    },
    queryResponse: {
      ...state.queryResponse,
      [flowId]: {
        ...state.queryResponse[flowId],
        [llmSinkId]: result,
      },
    },
  };
};

const setQuery = (state, action) => {
  const { query, flowId } = action.payload;

  return {
    ...state,
    query: {
      ...state.query,
      [flowId]: query,
    },
  };
};

const setRAGNodeFormData = (state, action) => {
  const { flowNodeId, formData } = action.payload;

  return {
    ...state,
    nodeFormData: {
      ...state.nodeFormData,
      [flowNodeId]: formData,
    },
  };
};

export default ragReducer;
